export default __webpack_public_path__ + "static/media/trade_assurance.2fd74791.svg";